export default "__VITE_ASSET__94d2d37a__"